export function centerActiveCarouselSelector(
	container: HTMLElement | null | undefined,
	activeIndex: number
) {
	const selectorElement = container?.children[activeIndex] as
		| HTMLElement
		| undefined;

	if (!container || !selectorElement) return;

	const containerRect = container.getBoundingClientRect();
	const elementRect = selectorElement.getBoundingClientRect();
	const targetScrollLeft =
		container.scrollLeft +
		elementRect.left -
		containerRect.left -
		(containerRect.width - elementRect.width) / 2;

	container.scrollTo({
		left: targetScrollLeft,
		behavior: 'smooth'
	});
}
